export const ADMIN = 'admin'
export const ADMIN_DASHBOARD = 'admin-dashboard'
export const ADMIN_USERS = 'admin-users'
export const ADMIN_USER = 'admin-user'
export const ADMIN_USER_EDIT = 'admin-user-edit'
export const ADMIN_USER_CREATE = 'admin-user-create'

export const ADMIN_COMPANIES = 'admin-companies'
export const ADMIN_COMPANY = 'admin-company'
export const ADMIN_COMPANY_EDIT = 'admin-company-edit'
export const ADMIN_COMPANY_CREATE = 'admin-company-create'
